import script from "./ForecastWdgt.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForecastWdgt.vue?vue&type=script&setup=true&lang=ts"

import "./ForecastWdgt.vue?vue&type=style&index=0&id=f0987630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0987630"]])

export default __exports__